import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SupportTicketsApiService } from '../../services/support-tickets/support-tickets-api.service';
import * as actions from '../actions/contact-us.actions';

@Injectable()
export class ContactUsEffects {
  constructor(
    private actions$: Actions,
    private supportTicketsApiService: SupportTicketsApiService,
  ) {}

  createSupportTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.ContactUsActionTypes.CREATE_SUPPORT_TICKET),
      switchMap((action: actions.CreateSupportTicket) => {
        return this.supportTicketsApiService
          .postSupportTickets({ supportTicket: action.payload.data })
          .pipe(
            map((result) => new actions.CreateSupportTicketSuccess()),
            catchError((error: HttpError) =>
              of(new actions.CreateSupportTicketFail({ error })),
            ),
          );
      }),
    ),
  );
}
